import "./App.css";
import "animate.css";
import { useState, useEffect } from "react";
import { data, translate } from "./data";

const TOTAL_QUESTIONS = 123;

let goodAnswerAudio;
let badAnswerAudio;
let audioDuration;

const audioStart = new Audio("./sounds/start.mp3");
audioStart.volume = 0.3;

function App() {
  const [isGameStarted, setIsGameStarted] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
  const [isAnswerIncorrect, setIsAnswerIncorrect] = useState(null);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isGameFinished, setIsGameFinished] = useState(false);
  const [isTipShowed, setIsTipShowed] = useState(false);
  const [currentLang, setCurrentLang] = useState(lang || "ru");
  const [disableBtns, setDisableBtns] = useState(false);
  const [answersData, setAnswersData] = useState({
    correctAnswers: 0,
    record: 0,
  });

  const saveDate = () => {
    console.log("Дата сохранена", answersData);
    player.setData(answersData);
  };

  const loadDate = () => {
    player.getData().then((date) => {
      console.log("Дата загружена", date);
      setAnswersData({
        ...answersData,
        record: date.record || 0,
      });
    });
  };

  const showAdv = () => {
    YandexSDK.adv.showFullscreenAdv({
      callbacks: {
        onClose: function (wasShown) {
          console.log(">>> Adv closed <<<");
        },
        onError: function (error) {
          // some action on error
        },
      },
    });
  };

  const showTip = () => {
    YandexSDK.adv.showRewardedVideo({
      callbacks: {
        onOpen: () => {
          console.log("Video ad open.");
          audioStart.pause();
          goodAnswerAudio?.pause();
          badAnswerAudio?.pause();
        },
        onRewarded: () => {
          console.log("Rewarded!");
          setIsTipShowed(true);
        },
        onClose: () => {
          console.log("Video ad closed.");
        },
        onError: (e) => {
          console.log("Error while open video ad:", e);
        },
      },
    });
  };

  const saveToLb = (value) => {
    YandexSDK.getLeaderboards().then((lb) =>
      lb.setLeaderboardScore("Answers", value)
    );
  };

  useEffect(() => {
    if (player) saveDate();
  }, [answersData.record]);

  useEffect(() => {
    if (player) loadDate();
  }, [player]);

  useEffect(() => {
    console.log("Дата с ответами", answersData);
  }, [answersData]);

  window.addEventListener("blur", () => {
    audioStart.pause();
    goodAnswerAudio?.pause();
    badAnswerAudio?.pause();
  });

  const chooseHandler = (index) => {
    setIsTipShowed(false);
    setSelectedAnswer(index);
    if (index === data[currentQuestion].correctAnswerIndex) {
      goodAnswerAudio = new Audio(
        `./sounds/good-${Math.floor(Math.random() * (13 - 1) + 1)}.mp3`
      );
      goodAnswerAudio.addEventListener("loadedmetadata", (e) => {
        audioDuration = e.target.duration.toFixed(3) * 1000;
        goodAnswerAudio.volume = 0.3;
        setTimeout(() => {
          setAnswersData({
            ...answersData,
            correctAnswers: (answersData.correctAnswers += 1),
          });
          if (currentQuestion === TOTAL_QUESTIONS) {
            if (answersData.correctAnswers > answersData.record) {
              setAnswersData({
                ...answersData,
                record: answersData.correctAnswers,
              });
              saveToLb(answersData.correctAnswers);
            }
            setIsGameFinished(true);
          } else {
            setCurrentQuestion((prevState) => prevState + 1);
          }
          setIsAnswerCorrect(false);
          setIsAnswerIncorrect(false);
        }, audioDuration);
      });

      goodAnswerAudio.play();
      setIsAnswerCorrect(true);
    } else {
      badAnswerAudio = new Audio(
        `./sounds/bad-${Math.floor(Math.random() * (11 - 1) + 1)}.mp3`
      );
      badAnswerAudio.addEventListener("loadedmetadata", (e) => {
        audioDuration = e.target.duration.toFixed(3) * 1000;
        badAnswerAudio.volume = 0.3;
        setTimeout(() => {
          if (currentQuestion === TOTAL_QUESTIONS) {
            if (answersData.correctAnswers > answersData.record) {
              setAnswersData({
                ...answersData,
                record: answersData.correctAnswers,
              });
              saveToLb(answersData.correctAnswers);
            }
            setIsGameFinished(true);
          } else {
            setCurrentQuestion((prevState) => prevState + 1);
          }
          setIsAnswerCorrect(false);
          setIsAnswerIncorrect(false);
        }, audioDuration);
      });

      badAnswerAudio.play();
      setIsAnswerIncorrect(true);
    }
  };

  return (
    <div className="app">
      <h1 className="title">{translate[currentLang].title}</h1>
      {isGameStarted && !isGameFinished && (
        <div
          className="tip animate__animated animate__bounceIn"
          onClick={showTip}
        >
          <img
            className="tip__image"
            src="./images/tip-button.webp"
            alt="Tip button"
          />
          <p className="tip__text">{translate[currentLang].hint}</p>
        </div>
      )}
      {isGameStarted && !isGameFinished && (
        <p className="app__counter animate__animated animate__fadeInDown">{`${currentQuestion}/${TOTAL_QUESTIONS}`}</p>
      )}
      <div className="app__container">
        {!isGameStarted && !isGameFinished && (
          <div
            className={`app__main-menu app__main-menu_start animate__animated animate__fadeIn`}
          >
            {/* {player && (
              <p className="app__record animate__animated animate__fadeInUp">
                {`${translate[currentLang].record} ${answersData.record}`}
              </p>
            )} */}
            <img className="d2-logo" src="./images/d2-logo.png" alt="logo" />
            <button
              disabled={disableBtns}
              className="button button_play"
              onClick={() => {
                setDisableBtns(true);
                setAnswersData({ ...answersData, correctAnswers: 0 });
                setTimeout(() => {
                  setIsGameStarted(true);
                  setDisableBtns(false);
                  showAdv();
                }, 1700);
                audioStart.play();
              }}
            >
              {translate[currentLang].play}
            </button>
          </div>
        )}
        {isGameStarted && !isGameFinished && (
          <div className="game">
            <div className="game__video-container">
              <video
                className={`game__image animate__animated animate__fadeIn`}
                src={data[currentQuestion].videoUrl}
                autoPlay
                preload="auto"
                loop
                width="100%"
                height="100%"
                playsInline
                key={currentQuestion}
              />
            </div>
            <div className="game__answers animate__animated animate__fadeIn">
              {data[currentQuestion].variants.map((item, index) => {
                return (
                  <button
                    disabled={isAnswerCorrect || isAnswerIncorrect}
                    className={`variant button button_variant 
                  ${selectedAnswer == index && isAnswerCorrect && "green"}
                  ${selectedAnswer == index && isAnswerIncorrect && "red"}
                  ${
                    data[currentQuestion].correctAnswerIndex == index &&
                    isTipShowed &&
                    "yellow"
                  }`}
                    key={index}
                    onClick={() => chooseHandler(index)}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        )}
        {isGameFinished && (
          <div className={`app__main-menu animate__animated animate__fadeIn`}>
            <p className="app__record">
              {`${translate[currentLang].result} ${answersData.correctAnswers}`}
            </p>
            <p className="app__record">{`${translate[currentLang].record} ${answersData.record}`}</p>
            <button
              disabled={disableBtns}
              className="button button_play"
              onClick={() => {
                setDisableBtns(true);
                setTimeout(() => {
                  setDisableBtns(false);
                  setAnswersData({ ...answersData, correctAnswers: 0 });
                  setIsGameStarted(true);
                  setIsGameFinished(false);
                  setCurrentQuestion(1);
                  showAdv();
                }, 1700);
                audioStart.play();
              }}
            >
              {translate[currentLang].again}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
